/*
Copyright (C) 2020 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import { defineMessages } from 'react-intl';

export default defineMessages({
  thumbnail: {
    id: 'ItemBrowserBody.ListGrid.headers.thumbnail',
    defaultMessage: 'Preview',
    description: 'The default label for the thumbnail column'
  },
  title: {
    id: 'ItemBrowserBody.ListGrid.headers.title',
    defaultMessage: 'Title',
    description: 'The default label for the title column'
  },
  type: {
    id: 'ItemBrowserBody.ListGrid.headers.type',
    defaultMessage: 'Type',
    description: 'The default label for the type column'
  },
  tags: {
    id: 'ItemBrowserBody.ListGrid.headers.tags',
    defaultMessage: 'Tags',
    description: 'The default label for the tags column'
  }
});
